import { ChevronDownIcon, ChevronUpIcon } from '@fukuri-admins/ui/common';
import { TableCell } from '@mui/material';
import clsx from 'clsx';
import { ActionTableColumnsType } from '../../../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../../../types/table/ActionTableSortParamsType';
import styles from './styles.module.scss';

type Props = {
  columns: ActionTableColumnsType[];
  onClickHeader?: (key: string) => void;
  sortParams?: ActionTableSortParamsType;
};

const TableColumns: React.FC<Props> = ({ columns, onClickHeader, sortParams }) => {
  return (
    <>
      {columns?.map((column: ActionTableColumnsType, key: number) => {
        const isSortable = column.sortable;
        const isActiveSort = isSortable ? sortParams.column === column.key : false;

        return (
          <TableCell
            key={key}
            onClick={() => {
              if (isSortable) {
                onClickHeader(column.key);
              }
            }}
            className={clsx(styles.tableHeaderCell)}
            data-testid='table-header'
          >
            <div className={clsx(styles.tableHeaderCellDiv)}>
              {column.label}
              {isSortable &&
                (isActiveSort ? (
                  sortParams.isAsc ? (
                    <ChevronUpIcon className={styles.sortIconActive} />
                  ) : (
                    <ChevronDownIcon className={styles.sortIconActive} />
                  )
                ) : (
                  <ChevronDownIcon className={styles.sortIconInactive} />
                ))}
            </div>
          </TableCell>
        );
      })}
    </>
  );
};

export default TableColumns;
